import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../@core/service/api.service';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { ErpRoles } from '../../../@models';
import { CompilationTypeData } from '../../../@models/erp/compilationData';

@Component({
  selector: 'ngx-erp-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {

  erpRoles: ErpRoles;
  docTypes = CompilationTypeData;

  constructor(
    private api: ApiService,
    private auth: AuthGuardService,
  ) { }

  ngOnInit(): void {
    const s = this.auth.loadMe().then(x => {
      this.erpRoles = x.erpRoles;
    });
  }

  access(val: string) {
    if (this.erpRoles) {
      switch(val) {
        case 'nrka': return this.erpRoles.admin || this.erpRoles.nrka;
        case 'materials': return this.erpRoles.admin || this.erpRoles.materials;
        case 'nrkg': return this.erpRoles.admin || this.erpRoles.nrkg;
        case 'core': return this.erpRoles.admin;
        case 'products': return this.erpRoles.admin || this.erpRoles.products;
        case 'productswrite': return this.erpRoles.admin || (this.erpRoles.products && !this.erpRoles.readOnlyProducts);
        case 'reports': return this.erpRoles.admin || this.erpRoles.reports;
        case 'utilities': return this.erpRoles.admin;
      }
    }
  }
}
